module.exports = "$ npm install react-tiles --save\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/install.html
 ** module id = 265
 ** module chunks = 0
 **/